import { createSelector } from 'reselect';

const selectCurrentPage = ({ currentPage }) => currentPage;

export const selectCurrentPageCode = createSelector(selectCurrentPage, ({ pageCode }) => pageCode);
